import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    getDoorCheckWorkSheet: [],
    getLotCheckWorkSheet: [],
    doorBulkResponse: '',
    reportsResponse: [],
    pdfDataArray: [],
}

const WorkSheetReducer = (state = initState, { type, payload }) => {

    switch (type) {
    
        case CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_SUCCESS: {
            return {
                ...state,
                getDoorCheckWorkSheet: payload.value
            }
        }
        case CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_LOT_CHECK_WORKSHEET_API_SUCCESS: {
            
            return {
                ...state,
                getLotCheckWorkSheet: payload.value
            }
        }
        case CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_SUCCESS: {
            return {
                ...state,
                doorBulkResponse: payload.value
            }
        }
        case CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.CREATE_REPORTS_API_SUCCESS: {
            return {
                ...state,
                reportsResponse: payload.value
            }
        }
        case CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.UPDATE_PDF_DATA: {
            return {
                ...state,
                pdfDataArray: payload.value
            }
        }
        default:
            return state
    }
}

export default WorkSheetReducer;
